import { ROUTES } from 'constants/routes';
import { matchPath } from 'react-router-dom';

export const matchAppRouteOutsideRoute = (pathname: string) =>
	Object.values(ROUTES)
		.map((routePattern) => matchPath(routePattern, pathname))
		.filter(Boolean)[0];
